import { ConfigColumns2 } from "../../types/configColumns2";

const merckDefaultColumns = (): ConfigColumns2[] => {
    const merckPalletId = { data: "merckPalletId", className: "nowrap", width: "33%", title: "MerckPalletId" };
    const merckBarcodeA = { data: "merckBarcodeA", className: "nowrap", width: "33%", title: "MerckBarcode" };
    const merckRang = { data: "merckRang", className: "nowrap", width: "33%", title: "MerckRang" };
    const merckDropPoint = { data: "merckDropPoint", className: "nowrap", width: "33%", title: "DropLocation" };
    const sscc = { data: "sscc", className: "nowrap", width: "33%", title: "SSCC" };

    return [sscc, merckPalletId, merckBarcodeA, merckRang, merckDropPoint];
};

export { merckDefaultColumns };
